module.exports = __webpack_public_path__ + "img/guide3.a9985413.png";